import {useState, useEffect} from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './nav.scss';

// Navigation Bar Component
function NavigationBar() {
    const [solid, setSolid] = useState('');
    const [scrolled, setScrolled] = useState(false);
    const [expanded, setExpanded] = useState(false);
    

    const listenScrollEvent = e => {
        if (window.scrollY > 60) {
            setSolid('solid');
        } else {
            setSolid('');
        }
    }

    // Handle smooth scroll to contact section with offset
    const handleContactClick = (e) => {
        e.preventDefault();
        setExpanded(false);
        const contactSection = document.getElementById('contactUs');
        if (contactSection) {
            const navbarHeight = 80; // Approximate navbar height
            const elementPosition = contactSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        if (window.scrollY > 60) {
            setSolid('solid');
        } else {
            setSolid('');
        }
        window.addEventListener('scroll', listenScrollEvent)      
        const handleScroll = () => {
        // Set scrolled to true if user has scrolled more than 10px, false otherwise
            setScrolled(window.scrollY > 10);
        };  
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

    });

    return (
        <Navbar expand="lg" fixed='top' className={solid + (scrolled ? ' scrolled' : '')} expanded={expanded} onToggle={e => setExpanded(e)}>
            <Container>
                {/* <Navbar.Brand href="/home">
                    <img className='nav_brand_image' alt="boldium logo"/>
                </Navbar.Brand> */}
                {/* <Nav className="me-auto">
                    <Nav.Link className="nav_home" href="#home">Home</Nav.Link>
                    <Nav.Link className="nav_principles" href="#principles">Our Values</Nav.Link>
                    <Nav.Link className="nav_projects" href="#projects">Projects</Nav.Link>
                    <Nav.Link className="nav_reviews" href="#googleReviews">Reviews</Nav.Link>
                    <Nav.Link className="nav_contactUs" href="#contactUs">Contact</Nav.Link>
                </Nav> */}
                {/* <Nav className="ms-auto">
                    <Nav.Link className="nav_contactUs" href="#contactUs">Contact</Nav.Link>
                </Nav> */}
                
                
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                    <Nav.Link className="nav_home" href="#home" onClick={() => setExpanded(false)}>Home</Nav.Link>
                    <Nav.Link className="nav_principles" href="#principles" onClick={() => setExpanded(false)}>Our Values</Nav.Link>
                    <Nav.Link className="nav_projects" href="#projects" onClick={() => setExpanded(false)}>Projects</Nav.Link>
                    <Nav.Link className="nav_reviews" href="#googleReviews" onClick={() => setExpanded(false)}>Reviews</Nav.Link>
                    <Nav.Link className="nav_contactUs" href="#contactUs" onClick={handleContactClick}>Contact</Nav.Link>                  
                </Nav>
                </Navbar.Collapse>
               
            </Container>
        </Navbar>
    );
  }
  
  export default NavigationBar;